var _rect, _path, _path2, _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_2868_2679)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6335 13.048L23.5778 19.7851C23.5778 19.7851 22.5942 18.7751 21.8312 18.3129C21.2456 17.9581 20.2343 17.5893 20.2343 17.5893L19.1364 15.1689L17.24 19.6043C17.24 19.6043 15.8872 19.9785 15.1939 20.4776C14.5084 20.9711 13.7716 22.0496 13.7716 22.0496L17.8887 12.7236C17.8887 12.7236 18.3129 12 19.1364 12C20.2592 12.0937 20.6335 13.048 20.6335 13.048Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7716 21.9997L12 26.0669H14.3455L15.6181 23.2723C16.3579 22.0619 16.9432 21.7195 18.2879 21.7003C19.4599 21.8697 20.0416 22.1496 20.6834 23.6216C21.8206 25.6493 22.7064 26.0401 24.4761 26.1667C27.4454 26.1667 27.9494 23.6828 28.065 21.1667L27.8333 20.7501C27.363 19.8316 26.9174 19.6576 25.9982 19.5794V21.9997C25.8758 23.4889 25.4492 23.946 24.4761 23.946C23.3782 24.0063 23.3677 23.5468 22.2553 21.9997C20.8804 20.0875 19.8295 19.4643 17.1901 19.5794C15.6232 20.0141 14.8516 20.4934 13.7716 21.9997Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_2679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5125 17.535H24.15C24.15 18.4463 24.9195 19.5195 26.1075 19.4925C27.2955 19.4655 27.885 20.5388 28.065 21.0788C28.11 21.0225 28.2435 20.64 28.1325 19.3913C27.8287 17.9738 27.0075 17.6475 26.5125 17.535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5125 17.535H24.15C24.15 18.4463 24.9195 19.5195 26.1075 19.4925C27.2955 19.4655 27.885 20.5388 28.065 21.0788C28.11 21.0225 28.2435 20.64 28.1325 19.3913C27.8287 17.9738 27.0075 17.6475 26.5125 17.535Z",
    stroke: "white",
    strokeWidth: 0.4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4167,
    cy: 15.75,
    r: 1,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_2679",
    x: 23.95,
    y: 17.3351,
    width: 4.42554,
    height: 4.45576,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_2679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_2679",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2868_2679",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBot);
export default __webpack_public_path__ + "static/media/DefaultBot.743649b4675adaec507c2ced0eaa5391.svg";
export { ForwardRef as ReactComponent };